module.exports = __webpack_public_path__ + "img/15-chinese.7f409d52.svg";